<template>
  <v-card :color="cardColor">
    <v-card-title>
      <div class="layout row ma-0">
        <div class="subheading">{{ title }}</div>
        <v-spacer />
        <!--        <div class="caption">-->
        <!--          <v-icon>trending_up</v-icon>-->
        <!--          {{subTitle}}-->
        <!--        </div>-->
      </div>
    </v-card-title>
    <v-responsive>
      <apexchart
        :type="type"
        height="270"
        :options="this.chartOptions"
        :series="series"
      />
    </v-responsive>
    <v-divider v-if="$slots.actions" class="mx-3" />
    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    title: String,
    gradient: {
      type: Boolean,
      default: false,
    },
    subTitle: String,
    icon: String,
    cardColor: {
      type: String,
      default: "white",
    },
    iconColor: {
      type: String,
      default: "success",
    },
    type: String,
    options: Object,
    labels: Array,
    series: Array,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "straight",
        },
        title: {
          // text: this.$props.title,
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: this.$props.labels,
        },
        labels: this.$props.labels,
      },
    };
  },
};
</script>

<style></style>
